import { ROUTES } from '../../../../constants/app'
import type { OperationsNode } from '../types/operations.types'

export type EntityHrefKind = 'organization' | 'schedule' | 'team'

/**
 * Public page URL for an entity referenced from the Operations panel. Kept in
 * `common/` so mobile deep links can reuse the same mapping.
 */
export const entityHref = (kind: EntityHrefKind, id: string): string => {
  switch (kind) {
    case 'organization':
      return `${ROUTES.ORG_ROOT}/${id}`
    case 'team':
      return `${ROUTES.TEAM_ROOT}/${id}`
    case 'schedule':
    default:
      return `${ROUTES.SCHEDULE_ROOT}/${id}`
  }
}

/**
 * Href for a tree node. Conferences and divisions are schedules in the API, so
 * every non-team node resolves to the schedule route.
 */
export const nodeHref = (node: OperationsNode): string =>
  node.type === 'team'
    ? entityHref('team', node.teamId)
    : entityHref('schedule', node.scheduleId)
